/**
 * <BasicInfo	/>
 *
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import basicInfoFields from './basicInfoFields';
import FieldItem from 'components/UI/CustomField/FieldItem';
import Panel from 'components/UI/Panel';
import locale from './locale';

class BasicInfo extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    let FieldItems = [];
    
    basicInfoFields.map((field, index)=>{
      const { label, required, isSettingItem } = field;
      if (isSettingItem) { 
        FieldItems.push(
          <FieldItem key={index} 
            label={label}
            required={required}
          />
        );
      }
    });


    return (
      <Panel title={__('Basic Info', locale)}>
        <div className='basic-info'>
          {FieldItems}
        </div>
      </Panel>
    )
  }
}

export default BasicInfo;



// WEBPACK FOOTER //
// ./src/containers/pages/StudentSettings/BasicInfo.js